<template>
    <table>
        <colgroup>
            <col v-for="item in currentColumns" :key="item.key" :style="{width:item.width}">            
        </colgroup>
        <thead>
            <tr>
                <template v-for="(col, index) in columns">
                    <th v-if="col.sortable"  :key="col.title">
                        <span>{{col.title}}</span>
                        <a :class="{on:col._sortType === 'asc'}"
                        @click="handleSortByAsc(index)"
                        >↑</a>
                        <a :class="{on:col._sortType==='desc'}"
                        @click="handleSortByDesc(index)"
                        >↓</a>
                    </th>
                    <th v-else :key="col.title">
                        {{col.title}}
                    </th>
                </template>
            </tr>
        </thead>
        <tbody>
            <tr v-for="row in currentData" :key="row.name">
                <td v-for="cell in currentColumns" :key="cell.key">
                    {{ row[cell.key] }}
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script>
export default {
    props:{
        columns:{
            type:Array,
            default:function(){
                return [];
            }
        },
        data:{
            type:Array,
            default:function(){
                return [];
            }
        }
    },
    data(){
        return{
            currentColumns:[],
            currentData:[]
        }
    },
    methods:{
        makeColumns(){
            this.currentColumns=this.columns.map((col,index)=>{
                col._sortType = 'normal';
                col._index = index;
                return col;
            });
        },
        makeData(){
            this.currentData=this.data.map((row, index)=>{
                row._index = index;
                return row;
            });
        },
        handleSortByAsc(index){
            var key=this.currentColumns[index].key;
            this.currentColumns.forEach(col=>{
                col._sortType='normal';
            });
            this.currentColumns[index]._sortType='asc';
            this.currentData.sort((a,b)=>{
                return a[key] > b[key] ? 1 : -1;
            })
        },
        handleSortByDesc(index){
            var key=this.currentColumns[index].key;
            this.currentColumns.forEach(col=>{
                col._sortType='normal';
            });
            this.currentColumns[index]._sortType='desc';
            this.currentData.sort((a,b)=>{
                return a[key] < b[key] ? 1 : -1;
            });
        }
    },
    mounted(){
        this.makeColumns();
        this.makeData();
    },
    watch:{
        data(){
            this.makeData();
            var sortedColumn=this.currentColumns.filter(col=>{
                return col._sortType !== 'normal';
            });

            if(sortedColumn.length > 0){
                if(sortedColumn[0]._sortType==='asc'){
                    this.handleSortByAsc(sortedColumn[0]._index);
                }else{
                    this.handleSortByDesc(sortedColumn[0]._index);
                }
            }
        }
    },
}
</script>
<style scoped>
table{
    width: 100%;
    margin-bottom: 24px;
    border-collapse: collapse;
    border-spacing: 0;
    empty-cells: show;
    border: 1px solid #e9e9e9;
}
table th{
    background: #f7f7f7;
    color: #5c6b77;
    font-weight: 600;
    white-space: nowrap;
}
table td, table th{
    padding: 8px 16px;
    border: 1px solid #e9e9e9;
    text-align: left;
}
table th a{
    display: inline-block;
    margin: 0 4px;
    cursor: pointer;
}
table th a.on{
    color: #3399ff;
}
table th a:hover{
    color: #3399ff;
}
</style>